// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import DropableLabel from "./DropableLabel";
import CorrectIcon from "../images/CorrectIcon.svg"
import InCorrectIcon from "../images/IncorrectNew.svg"

import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialCost from "../images/Social-cost.svg"
import DemandIcon from "../images/Demand.svg"
import { Grid, Typography } from "@material-ui/core";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";


var CanvasJSChart = CanvasJSReact.CanvasJSChart;
const BubbleAndLine5 = (props) => {
  const [allCorrect, setAllCorrect] =useState(false)
  const { qIndex, handleReloadClick, classes } = props;
  const [chartData, setChartData] =useState([])
  const [submit, setSubmit] =useState(false)
  const canvasRef = useRef(null);

  // State to keep track of the selected option
  const [selectedParagraph, setSelectedParagraph] = useState("");

  // Define the letters for each option
  const optionLabels = ['a.', 'b.', 'c.'];

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "spline",
      color: "#8C479B",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 16, cursor: 'pointer', z: 3}, {x: 50, y: 20, cursor: 'pointer', z: 3}, {x: 150, y: 30, cursor: 'pointer', z: 3}, {x: 250, y: 40, cursor: 'pointer', z: 3}, {x: 290, y: 44, cursor: 'pointer', z: 3}]
    },
    {
      type: "spline",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 6, cursor: 'pointer', z: 1}, {x: 50, y: 10, cursor: 'pointer', z: 1}, {x: 150, y: 20, cursor: 'pointer', z: 1}, {x: 250, y: 30, cursor: 'pointer', z: 1}, {x: 290, y: 34, cursor: 'pointer', z: 1}]
    },
    {
      type: "spline",
      color: '#00b1d9',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 34, cursor: 'pointer'}, {x: 100, y: 25, cursor: 'pointer'}, {x: 200, y: 15, cursor: 'pointer'}, {x: 250, y: 10, cursor: 'pointer'}, {x: 290, y: 6, cursor: 'pointer'}]
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 15,
      color: 'green',
      dataPoints: []
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 15,
      color: 'red',
      dataPoints: []
    },
  ]

  useEffect(() => {
    setChartData(data)
  }, [])

  useEffect(() => {
    if(submit === true){
      setAllCorrect(questionsAnswers[qIndex].answer === selectedParagraph)
    }
  },[submit])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    // backgroundColor: "red",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile && 200,
    width: isMobile && 320
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const clearScreen = () => {
    setSubmit(false)
    setSelectedParagraph("")
  }

  function submitButtonAction() {
    if(submit){
      if(!allCorrect){
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  const getOptionBackgroundColor = (index) => {
    console.log("getOptionBackgroundColor")
    if(submit){
      return selectedParagraph === index ? allCorrect ? "#508A05" : "#e83423" : "transparent"
    }else{
      return selectedParagraph === index ? "#00b1d9" :  'transparent'
    }
  }

  const getOptionColor = (index) => {
    console.log("getOptionColor")
    if(submit){
      return selectedParagraph === index ? allCorrect ? "white" : "#FAD6D3" : "#043e4b"
    }else{
      return "#043e4b"
    }
  }

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer4}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
           <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "flex-start" }}>
            <h3 className={classes.questionText5}>{questionsAnswers[qIndex].question}</h3>
            <div className={`animate__animated animate__bounceIn ${classes.optionContainer3}`}>

            <div className={`animate__animated animate__bounceIn ${classes.optionGrid3}`}>

              {questionsAnswers[qIndex].options.map((paragraph, index) => (
                <div
                  key={index}
                  className={classes.optionContainer5}
                  style={{
                    pointerEvents: submit ? 'none' : 'auto',
                    color: getOptionColor(index),
                    backgroundColor: getOptionBackgroundColor(index),  // Background for selected paragraph
                    // color: selectedParagraph === paragraph ? '#0f5132' : 'black',  // Text color for selected paragraph
                  }}
                  onClick={() => setSelectedParagraph(index)}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#CADDDF'
                    // e.target.style.color = '#FAD6D3'
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = selectedParagraph === index ? '#00b1d9' : 'transparent'
                    // e.target.style.color = selectedParagraph === index ? '#FAD6D3' : '#043e4b'
                  }}
                >
                  {optionLabels[index]}
                  <span style={{ marginLeft: 10 }}/>
                  {paragraph}
                </div>
              ))}

            </div>
          </div>

            {submit && 
            <div className={classes.answerTextContainer}>
              {!allCorrect ?
                <div className={classes.incorrectAnswerContainer}>
                  <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon}/>
                </div>
              : 
              <Grid container className={classes.correctAnswerContainer}>
                  <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon}/>
                  <Typography className={classes.answerText}>
                  Since the market does not take into account all of the costs, the market produces units for which the social cost exceeds the benefit.
                  </Typography>
                </Grid>
              }
            </div>
            }
           </div>
          </div>
        </div>
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
          <DropableLabel
            right={isMobile ? '-24%' : "-20%"}
            marginTop={isMobile ? "12%" : "25%"}
            rotate={"rotate(270deg)"}
            label={"PRICE"}
          />
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>

          {/* <img src={SocialCost} alt="" className={classes.socialCostIcon3} /> */}
          <img src={SocialCost} alt="" className={classes.socialCostIcon} />
          <img src={supplyIcon} alt="" className={classes.supplyIcon}/>
          <img src={DemandIcon} alt="" className={classes.demandIcon}/>

          {/* <img src={supplyIcon} alt="" className={classes.supplyIcon3} /> */}
          <CanvasJSChart options = {options}  ref={canvasRef}/>
          <DropableLabel
            right={isMobile ? "70%": "75%"}
            marginTop={"0%"}
            rotate={"rotate(0deg)"}
            label={"QUANTITY"}
          />

          {/* <img src={DemandIcon} alt="" style={{ height: 80, width: 80, position: "absolute", zIndex: 10, right: "-12%", top: 380 }}/> */}
          {/* {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
            </div>
          } */}
          
          <div className={classes.buttonContainer}>
            {
            getButtonText() !== 'Next' ? (<>
              <button className={classes.submitButtom} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.submitButtom} style={{color: "#00b1d9", marginLeft: 20, backgroundColor: '#fff' }} onClick={() => clearScreen()}>Clear</button>
              </>) : <button className={classes.submitButtomNext}  style={{ marginLeft: "10%" }} onClick={() => handleReloadClick()}>{getButtonText()}</button>
            }
          </div>
        </div>
      </div>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine5);
